import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PageTransition from "@/components/PageTransition";

import Landing from "@/pages/Landing";
import CodeEntry from "@/pages/CodeEntry";
import EventDetail from "@/pages/EventDetail";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import CustomGift from "@/pages/CustomGift";
import CollectiveChoice from "@/pages/CollectiveChoice";
import LastMinuteGift from "@/pages/LastMinuteGift";
import AdminSettings from "@/pages/AdminSettings";
import AdminOperations from "@/pages/AdminOperations";
import SpecialGifts from "@/pages/SpecialGifts";
import OfferedGifts from "@/pages/OfferedGifts";
import Wishlist from "@/pages/Wishlist";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEventForm from "@/pages/AdminEventForm";
import AdminEventDetail from "@/pages/AdminEventDetail";
import AdminCatalog from "@/pages/AdminCatalog";
import AdminProductForm from "@/pages/AdminProductForm";
import AdminCustomRequests from "@/pages/AdminCustomRequests";
import AdminCommercial from "@/pages/AdminCommercial";
import AdminFinance from "@/pages/AdminFinance";
import AdminHR from "@/pages/AdminHR";
import AdminSuppliers from "@/pages/AdminSuppliers";

function AppRoutes() {
  return (
    <PageTransition>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/code" element={<CodeEntry />} />
        <Route path="/event/:code" element={<EventDetail />} />
        <Route path="/event/:code/shop" element={<Shop />} />
        <Route path="/event/:code/shop/product/:productId" element={<ProductDetail />} />
        <Route path="/event/:code/custom" element={<CustomGift />} />
        <Route path="/event/:code/collective" element={<CollectiveChoice />} />
        <Route path="/event/:code/lm/:productId" element={<LastMinuteGift />} />
        <Route path="/event/:code/special" element={<SpecialGifts />} />
        <Route path="/event/:code/offered" element={<OfferedGifts />} />
        <Route path="/event/:code/wishlist" element={<Wishlist />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/events/new" element={<ProtectedRoute><AdminEventForm /></ProtectedRoute>} />
        <Route path="/admin/events/:id" element={<ProtectedRoute><AdminEventDetail /></ProtectedRoute>} />
        <Route path="/admin/events/:id/edit" element={<ProtectedRoute><AdminEventForm /></ProtectedRoute>} />
        <Route path="/admin/catalog" element={<ProtectedRoute><AdminCatalog /></ProtectedRoute>} />
        <Route path="/admin/catalog/new" element={<ProtectedRoute><AdminProductForm /></ProtectedRoute>} />
        <Route path="/admin/catalog/:id/edit" element={<ProtectedRoute><AdminProductForm /></ProtectedRoute>} />
        <Route path="/admin/custom-requests" element={<ProtectedRoute><AdminCustomRequests /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
        <Route path="/admin/operations" element={<ProtectedRoute><AdminOperations /></ProtectedRoute>} />
        <Route path="/admin/logistics" element={<ProtectedRoute><AdminOperations /></ProtectedRoute>} />
        <Route path="/admin/commercial" element={<ProtectedRoute><AdminCommercial /></ProtectedRoute>} />
        <Route path="/admin/finance" element={<ProtectedRoute><AdminFinance /></ProtectedRoute>} />
        <Route path="/admin/suppliers" element={<ProtectedRoute><AdminSuppliers /></ProtectedRoute>} />
        <Route path="/admin/hr" element={<ProtectedRoute><AdminHR /></ProtectedRoute>} />
      </Routes>
    </PageTransition>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster richColors position="top-center" />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
